import { Injectable, OnDestroy } from '@angular/core';
import { Capacitor, CapacitorHttp } from '@capacitor/core';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { BehaviorSubject, EMPTY, from, Observable, of, Subscription, throwError } from 'rxjs';
import { catchError, switchMap, retry, finalize, delay } from 'rxjs/operators';
import { StorageService } from './storage.service';
import { Dialog } from '@capacitor/dialog';
import { Device } from '@capacitor/device';
import { UserService } from './user.service';
import { Swiper } from 'swiper';
import { Browser } from '@capacitor/browser';
import { Calendar } from '@awesome-cordova-plugins/calendar/ngx';
import { FileOpener } from '@capacitor-community/file-opener';
import { Filesystem, Directory, DownloadFileResult } from '@capacitor/filesystem';
import { version, build } from '../../../package.json';
import { App } from '@capacitor/app';
import { Share } from '@capacitor/share';
import { environment } from "src/environments/environment";
import { StatusBar, Style } from '@capacitor/status-bar';

import {
  FirebaseMessaging,
  GetTokenOptions,
} from "@capacitor-firebase/messaging";
import { Router } from '@angular/router';
import { Badge } from '@capawesome/capacitor-badge';

const TOKEN_KEY = 'jwttoken';

@Injectable({
  providedIn: 'root'
})
export class GlobalService implements OnDestroy {
  private subscriptions = new Subscription();

  // Track recent requests for throttling
  private recentRequests: { [key: string]: number } = {};

  // State and config
  public messageBoardData = new BehaviorSubject<Array<any>>([]);
  public tabValues = new BehaviorSubject<Array<any>>([]);
  public deviceInfo: any = null;
  public cMCVersion = version;
  public apiURL: string = environment.apiURL;
  public siteUrl: string = environment.siteUrl;
  public stripeKey: string = environment.stripeKey;
  public mapsApiKey: string = environment.mapsKey;
  public logging_out = false;
  public appName: string = environment.appName;
  public merchantName: string = "Arden:Twenty";
  public primary_color: string = "rgb(255,120,0)";
  public primary_color_hex: string = "#ff7800";
  public statusBarText: string = "DARK";
  public clubName: string;
  public pushPermission = new BehaviorSubject<boolean>(false);
  public multiClubs = false;
  public nothingHere = "There's nothing here at the moment";
  public isAuthenticated = new BehaviorSubject<boolean | null>(null);
  public isAuthenticated$ = this.isAuthenticated.asObservable();
  public token = '';
  public loader = false;
  public requestURL: string;
  public isNative = Capacitor.isNativePlatform();
  public isApp = Capacitor.isNativePlatform();
  public appPlatform: any;
  public appVersion: any;
  public appBuild: any;
  public deviceOS: any;
  public appType: any;
  public notificationData: any = [];
  public downloadProgress = 0;
  private errorPopup: boolean = true;
  private postingError = false;
  private inNonLoaders = false;
  private isLoading = false;
  private readTimeout = 120000;
  private connectTimeout = 60000;
  public jwttoken: string;
  public club_id: string;
  public user_id: string;
  public cached: boolean = true;
  public clubLogoChanged = new BehaviorSubject<boolean>(false);
  public preferWheel = false;

  public mapsReady: boolean = false;
  public mapsReadyCatCalled: boolean = false;
  public mapsReadyClubActivities: boolean = false;

    public streetHarassment: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([false]);
    public showInfoModal: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  // Swiper configs
  public swiperConfig = new Swiper('.swiper', {
    direction: 'horizontal',
    loop: true,
    zoom: { maxRatio: 3, minRatio: 1 },
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    modules: [],
  });

  public swiperStaticConfig = new Swiper('.swiper', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    modules: [],
  });

  private errorURL = 'ionic_postError';
  private logoutURL = 'ionic_logout';
  private sendNotificationsURL = 'ionic_sendNotifications';

  private nonLoaderURLs = [
    this.apiURL + 'ionic_postError',
    this.apiURL + 'ionic_postPushToken',
    this.apiURL + 'ionic_postUsageStats',
    this.apiURL + 'ionic_postSwitchDM',
    this.apiURL + 'ionic_clublogo',
    this.apiURL + 'ionic_getMembership',
    this.apiURL + 'ionic_postNotificationSettings',
    this.apiURL + 'ionic_sendNotifications',
    this.apiURL + 'ionic_userHelpSearch',
    this.apiURL + 'ionic_getTrainingGroupRegister',
    this.apiURL + 'ionic_getMessageBoard',
    this.apiURL + 'ionic_meetSearch',
    this.apiURL + 'ionic_raceSearch',
    this.apiURL + 'ionic_eventSearch',
    this.apiURL + 'ionic_getEventCalendarHistory',
    this.apiURL + 'ionic_memberSearch',
    this.apiURL + 'ionic_getTrainingLocations',
    this.apiURL + 'ionic_getHighlightEventorOffer',
    this.apiURL + 'ionic_getAppTabValues',
    this.apiURL + 'ionic_modalViewed',
    this.apiURL + 'ionic_postAppleActivity',
    this.apiURL + 'ionic_getTrainingGroupDetails_V2',
    this.apiURL + 'ionic_postPageViewed',
    this.apiURL + 'ionic_getLatestGroupMsg',
    this.apiURL + 'ionic_postModalViewed',
  ];

  constructor(
    private alertController: AlertController,
    private toastCtrl: ToastController,
    private storage: StorageService,
    private userService: UserService,
    private calendar: Calendar,
    private loadingCtrl: LoadingController,
     private router: Router,
  ) {
  this.checkAuth();
  }

async checkAuth() {
  const token = await this.storage.getString('jwttoken'); // your method to get token
  console.log('Token from storage:', token.value);

  if (token && token.value) {
    this.isAuthenticated.next(true);
  }
  else {
    this.isAuthenticated.next(false);
}
}
  // --- UI Helpers ---

  generateUniqueId(): string {
  // Generates a UUID v4
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

  async showAlert(message: string): Promise<void> {
    await Dialog.alert({ title: 'Stop', message });
  }

  async presentAlert(header: string, message: string, buttons: any[]): Promise<void> {
    const alert = await this.alertController.create({
      cssClass: 'buttonCss',
      header,
      message,
      buttons
    });
    await alert.present();
    await alert.onDidDismiss();
  }

  async presentToast(message: string, length: number, position: any): Promise<void> {
    const toast = await this.toastCtrl.create({
      message,
      duration: length,
      position,
      animated: true
    });
    toast.present();
  }

  // --- File Download/Opening ---

  async downloadGPX(url: string, type: 'gpx' | 'tcx'): Promise<void> {
    let route = url.match(/\d+/g)[0];
    let now = new Date();
    let timestamp = now.getUTCMilliseconds();
    let filename: string, mimeType: string;
    if (type === 'gpx') {
      mimeType = 'application/gpx+xml';
      filename = `route_${route}_${timestamp}.gpx`;
    } else {
      filename = `plan${route}_${timestamp}.tcx`;
      mimeType = 'application/gpx+tcx';
    }

    const status = await Filesystem.checkPermissions();
    if (status.publicStorage === 'granted') {
      Filesystem.downloadFile({
        url,
        path: filename,
        directory: Directory.Documents,
        progress: true,
        recursive: true
      }).then((res: DownloadFileResult) => {
        if (res.path) this.openGpx(res.path, mimeType);
      }).catch(() => {});
    } else {
      Filesystem.requestPermissions();
    }
  }

  private async openGpx(filePath: string, mimeType: string): Promise<void> {
    let openDefault = Capacitor.getPlatform() !== 'ios';
    let options = { filePath, openWithDefault: openDefault };
    FileOpener.open(options)
      .then(() => console.log('File is opened'))
      .catch(e => console.log('Error opening file', e));
  }

  async downloadPDF(url: string): Promise<void> {
    let shareUrl = url.replace(this.apiURL, '');
    if (!Capacitor.isNativePlatform()) {
      this.openPdf(url);
      return;
    }
    const sub = (await this.request('get', true, shareUrl, null)).subscribe(
      async (res) => {
        let mime_type = res.mime_type;
        let data = res.filedata;
        let title = res.new_title;
        try {
          const result = await Filesystem.writeFile({
            path: title,
            data: data,
            directory: Directory.Documents,
            recursive: true
          });
          let options = { filePath: result.uri, contentType: mime_type, openWithDefault: true };
          FileOpener.open(options)
            .then(() => console.log('File is opened'))
            .catch(e => console.log('Error opening file', e));
        } catch (e) {
          console.error(e);
          this.openPdf(url);
        }
      }
    );
    this.subscriptions.add(sub);
  }



  openPdf(file: string): void {
    Browser.open({ url: file });
  }

  // --- App Details and Device Info ---

  async getAppDetails(): Promise<boolean | void> {

    const currentRoute = this.router.url;
//console.log('Current route:', currentRoute);

if( currentRoute === '/login' || currentRoute === '/registration' ) {
  return;
}
  
    try {
     
           await this.storage.getObject('clubDetails').then((data: any) => {  
            this.jwttoken = data.jwttoken;
          });
      
    //  if (!this.user_id || !this.club_id) {
        this.user_id = this.userService.user_id
          // console.log('USER ID:', this.user_id);
        // Subscribe to clubID$ and assign the emitted value to this.club_id
        this.userService.clubID$.subscribe((id: number) => {
          this.club_id = id != null ? id.toString() : '';
        });
      } catch (e) {
        console.error('Error getting app details:', e);
        return;
      } 
    }
    async getDeviceDetails(): Promise<boolean | void> {

      if (!this.appPlatform || !this.deviceOS) {
        await Device.getInfo().then(deviceInfo => {
          this.appPlatform = deviceInfo.platform;
          this.deviceOS = deviceInfo.operatingSystem;
        });
      }
      if (this.isApp) {
        if (!this.appVersion || !this.appBuild || !this.appType) {
          await App.getInfo().then(appInfo => {
            this.appVersion = appInfo.version;
            this.appBuild = appInfo.build;
            this.appType = appInfo.name;
          });
        }
      } else {
        if (!this.appVersion || !this.appBuild) {
          this.appVersion = version;
          this.appBuild = build;
        }
      }
      return true;
    } 

  protected async generateUrl(url: string): Promise<string> {
    return this.apiURL + url;
  }

  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // --- HTTP Requests ---

  public async loginRequest(method: string, loader: boolean, url: string, body?: any): Promise<Observable<any>> {
    url = await this.generateUrl(url);
    this.requestURL = url;
    this.loader = loader;
    let reqHeaders = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };
    let options = {
      url: url,
      headers: reqHeaders,
      data: body,
      readTimeout: this.readTimeout,
      connectTimeout: this.connectTimeout
    };
    this.presentLoading();
    return from(CapacitorHttp.request({ ...options, method })).pipe(
      switchMap(async _ => {
        this.closeLoading();
        if (_.status === 200) {
          return _.data;
        } else {
          throw new Error(this.handleKnownError('knownError', [_]));
        }
      }),
      catchError((error: any) => {
        this.closeLoading();
        this.handleError('getDetails', [error]);
        return throwError(() => error);
      }),
    );
  }

  public async request(method: string, loader: boolean, url: string, body?: any): Promise<Observable<any>> {
    url = await this.generateUrl(url);
    this.requestURL = url;
    this.loader = loader;

    // --- Throttle duplicate requests ---
    const reqKey = method + ':' + url + ':' + JSON.stringify(body || {});

    const now = Date.now();
    const throttleMs = 2000; // 2 second window
    if (this.recentRequests[reqKey] && now - this.recentRequests[reqKey] < throttleMs) {
      // Block duplicate request
      return of(null);
    }
    this.recentRequests[reqKey] = now;

    if (!this.jwttoken || !this.user_id || !this.club_id ) {
      await this.getAppDetails();
    }
    if (!this.appPlatform || !this.appVersion || !this.appBuild || !this.appType || !this.deviceOS) {
      await this.getDeviceDetails();
    }

    let reqHeaders = {
      'Authorization': 'bearer ' + this.jwttoken,
      'User-Id': this.user_id,
      'Club-Id': this.club_id,
      'Appversion': this.appVersion,
      'Build': this.appBuild,
      'Cmcversion': this.cMCVersion,
      'Platform': this.appPlatform,
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    let requestBody: any = {};
    if (body) {
      Object.entries(body).forEach(([key, value]) => {
        if (Number.isInteger(value)) value = value.toString();
        else if (!value) value = "";
        else if (Array.isArray(value)) value = value.join(',');
        else value = value.toString();
        requestBody[key] = value;
      });
    }

    let options;
    if (method === 'get') {
      options = {
        url: url,
        headers: reqHeaders,
        params: requestBody,
        readTimeout: this.readTimeout,
        connectTimeout: this.connectTimeout
      };
    }
    if (method === 'post') {
      options = {
        url: url,
        headers: reqHeaders,
        data: requestBody,
        readTimeout: this.readTimeout,
        connectTimeout: this.connectTimeout
      };
    }

    this.inNonLoaders = this.nonLoaderURLs.includes(this.requestURL);
    if (!this.inNonLoaders) {
      this.presentLoading();
    }

    return from(CapacitorHttp.request({ ...options, method })).pipe(
      retry({
        count: 3,
        delay: (error, retryCount) => {
          console.log('Retry attempt:', retryCount, 'Error:', error);
          console.log('Request URL:', this.requestURL);
          return  error.status == 403 ? of(null).pipe(delay(1000)) : of(null);
        },
        resetOnSuccess: true
      }),
      switchMap((response: { status: number; data: any }) => {
        console.log('Response from request:', response);
        console.log('Request URL:', this.requestURL);
        if (response.status === 200) {
          return of(response.data);
        } else if (response.status === 503) {
          return of(response.data);
        }  else {
          this.handleKnownError('getDetails', [response]);
          console.log('Error in request:', response);
          return EMPTY;
        }
      }),
      catchError((error: any) => {
        this.handleError('getDetails', [error]);
        console.log('Error in request:', error);
        return EMPTY;
      }),
      finalize(() => {
        this.closeLoading();
      })
    );
  }

  // --- Error Handling ---

  private handleKnownError<T>(operation = 'operation', result?: T): string {
    let error = result[0].error;
    let status = result[0].status;
    let message = result[0].data.message;

    if (message.includes('Missing security')) {
      message = 'Failed to connect to server';
        return;
    }
  if (message.includes('Unable to resolve host')) {
      message = 'Failed to connect to server';
        return;
    }else
    if (message.includes('Wrong number')) {
      message = 'Failed to connect to server';
        return;
    }else if (message.includes('You provided')) {
      message = 'Failed to connect to server';
        return;
    }
    else if (message.includes('failed to connect to app.connectmyclub.co.uk')) {
      message = 'Failed to connect to server';
    }
    this.presentToast(message, 3000, 'bottom');
    if (status !== 418) {
      this.sendError(message, status);
    }
    return message;
  }

  private handleError<T>(operation = 'operation', result?: T): Observable<T> {

    let code = result[0].code;
    let message = result[0].message || result[0].data?.message;

    if (this.requestURL.includes("ionic_postPushToken") || this.requestURL.includes("ionic_postUsageStats") || this.requestURL.includes("ionic_postPageViews")) {
      return of(result as T);
    }
    if (["SocketTimeoutException", "TimeoutError", "Request timeout", "The request timed out.", "The network connection was lost.", "The Internet connection appears to be offline.", "Failed to fetch", "Network Error", "Request aborted"].includes(message)) {
      message = {
        "SocketTimeoutException": "Timed Out",
        "TimeoutError": "Request timeout",
        "Request timeout": "Request timeout",
        "The request timed out.": "Request timed out",
        "The network connection was lost.": "Network Error",
        "The Internet connection appears to be offline.": "The Internet connection appears to be offline.",
        "Failed to fetch": "Server error/undergoing maintenance",
        "Network Error": "Network Error",
        "Request aborted": "Request aborted"
      }[message] || message;
    }

    console.error(`Error in ${operation}:`, message, 'Code:', code);
    if( message ){

 
    if( message.includes("Wrong number of") || message.includes('You provided') || message.includes('Token') || message.includes('Please try again') || message.includes('Failed to connect to server') || message.includes('Unable to resolve host') || message.includes('failed to connect to app.connectmyclub.co.uk') || message.includes('Missing security')) {
       return of(result as T);
        }
   }
       

    if (!message) message = "An unknown error has ocurred";
    this.presentToast(message, 3000, 'bottom');
    this.sendError(message, code);
    return of(result as T);
  }

  async sendError(error: string, status: any): Promise<void> {
    this.postingError = true;
    const info = await Device.getInfo();
    let deviceModel = info.model;
    if (this.requestURL.includes("ionic_postError")) return;
    let dataString = {
      'section': this.requestURL,
      'platform': this.appPlatform,
      'device': deviceModel,
      'error': error,
      'version': this.appVersion,
      'build': this.appBuild,
      'status': status
    };
    const sub = (await this.request('post', false, this.errorURL, dataString)).subscribe(
      async (res) => {
        this.postingError = false;
        let newToken = res.jwttoken;
        await this.storage.setString('jwttoken', newToken);
      }
    );
    this.subscriptions.add(sub);
  }

  //post page viewed
  
  async postPageViewed(route: string): Promise<void> {
    let url =  'ionic_postPageViews'
    let dataString = {
      'route': route
    };
    const sub = (await this.request('post', false, url, dataString)).subscribe(
      async (res) => {
        console.log('postPageViewed', res);
      }
    );
    this.subscriptions.add(sub);
  }


    async usageStats(getting: string): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      await Badge.clear();
    } 

  let identifier = null;
  await this.storage.getString('identifier').then( async (data:any) => {

    identifier = data.value;
   console.log('Device identifier:', identifier);

   let dataString = {
      'identifier': identifier
    };
      const sub = (await this.request('post', false, 'ionic_postUsageStats', dataString)).subscribe(
        async (res) => {
          console.log('usageStats', res);
          this.userService.unreadNotifications.next([]);
          this.userService.unreadNotifications.next(res.unread);
          await this.storage.setString('jwttoken', res.jwttoken);

          this.streetHarassment.next(res.streetHarassment);


         /// alert('Device identifier: ' + res.identifier + ' - ' + identifier);
          // alert('logout: ' + res.logout );
          if( res.logout ){
            this.logout();
          }


        }
      );
      this.subscriptions.add(sub);
    });
  }

  // --- Notifications ---

  async sendNotifications(section: string, id: any): Promise<void> {
    let dataString = { 'section': section, 'id': id };
    const sub = (await this.request('post', false, this.sendNotificationsURL, dataString)).subscribe();
    this.subscriptions.add(sub);
  }

  // --- Loading ---

  async presentLoading(): Promise<void> {
    this.isLoading = true;
    this.loadingCtrl.getTop().then(async hasLoading => {
      if (!hasLoading && !this.inNonLoaders) {
        return await this.loadingCtrl.create({
          mode: "ios",
          showBackdrop: true,
          spinner: "dots",
          translucent: true,
          backdropDismiss: true
        }).then(a => {
          a.present().then(() => {
            if (!this.isLoading) {
              a.dismiss().then(() => console.log('abort presenting'));
            }
          });
        });
      }
    });
  }
/*
  async closeLoading(): Promise<void> {
    this.isLoading = false;
    await this.loadingCtrl.getTop().then(async hasLoading => {
      if (hasLoading) {
        this.loadingCtrl.dismiss();
      }
    });
  }*/

  async closeLoading(): Promise<void> {
    let loading = await this.loadingCtrl.getTop();
    while (loading) {
      await this.loadingCtrl.dismiss();
      loading = await this.loadingCtrl.getTop();
    }
}

  // --- Auth ---

  async logout(): Promise<void> {

const currentRoute = this.router.url;
console.log('Current route:', currentRoute);

if( currentRoute === '/login' || currentRoute === '/registration' ) {
  return;
}


    this.isAuthenticated.next(false);
    let info = await Device.getInfo();
    let platform = info.platform;
    let device = await Device.getId();
    let uuid = device.identifier;
    let dataString = { 'platform': platform, 'uuid': uuid };
    this.logging_out = true;
    const sub = (await this.request('post', false, this.logoutURL, dataString)).subscribe(
      async () => {
        this.storage.clear();

        this.userService.jwttoken =  null
        this.jwttoken =  null
        this.userService.user_id = null;
        this.user_id = null;
        this.club_id = null;

         let primary_color = '#ff7800';
              let primary_color_rgb ='rgb(255,120,0)'
               let secondary_color = '#FFFFFF';
               let secondary_color_rgb = 'rgb(255,255,255)' ;
               let tertiary_color =  '#ff7800';
               let tertiary_color_rgb ='rgb(255,120,0)'
               tertiary_color_rgb = primary_color_rgb;
              this.userService.setThemeColors(
                primary_color,
                primary_color_rgb,
                secondary_color,
                secondary_color_rgb,
                tertiary_color,
                tertiary_color_rgb
              );

        
       this.router.navigate([''], { replaceUrl: true });
      }
    );
    this.subscriptions.add(sub);
  }

async setStatusBar(bg: string, text: string): Promise<void> {

  return;
  if (Capacitor.isNativePlatform()) {
    // Ensure bg is a valid hex string
    if (!/^#[0-9A-Fa-f]{6}$/.test(bg)) {
      bg = '#00FF7800'; // fallback
    }
    await StatusBar.setBackgroundColor({ color: bg });
    await StatusBar.setStyle({ style: text === 'DARK' ? Style.Dark : Style.Light });
    
  }
}

  async registerToken(pushToken: string): Promise<void> {


    let appUsedClub = 'appused_' + this.club_id;
    let reset = true;
    await this.storage.getString(appUsedClub).then(async (data: any) => {
      if (data.value == 'true') reset = false;
      let info = await Device.getInfo();
      let platform = info.platform;
      let device = await Device.getId();
      let uuid = device.identifier;
      let dataString = { 'platform': platform, 'uuid': uuid, 'token': pushToken, 'reset': reset };
      setTimeout(async () => {
        let sub = (await this.request('post', false, 'ionic_postPushToken', dataString)).subscribe(
          async (res) => {
            if (!res) return;
            await this.storage.setString(appUsedClub, 'true');
          }
        );
        this.subscriptions.add(sub);
      }, 1000);
    });
  }

  async switchLogout(): Promise<void> {
    let info = await Device.getInfo();
    let platform = info.platform;
    let device = await Device.getId();
    let uuid = device.identifier;
    let dataString = { 'platform': platform, 'uuid': uuid };
    const sub = (await this.request('post', false, this.logoutURL, dataString)).subscribe(
      async () => {
        document.documentElement.style.setProperty(`--ion-color-primary`, '#ff7800');
        document.documentElement.style.setProperty(`--ion-color-base-rgb`, 'rgb(255,120,0)');
        document.documentElement.style.setProperty(`--ion-color-primary-shade`, 'rgb(255,120,0)');
        document.documentElement.style.setProperty(`--ion-color-primary-tint`, 'rgb(255,120,0)');
        document.documentElement.style.setProperty(`--ion-color-primary-contrast`, '#FFFFFF');
        document.documentElement.style.setProperty(`--ion-color-contrast-rgb`, 'rgb(255,255,255)');
        document.documentElement.style.setProperty(`--ion-color-tertiary`, '#ff7800');
        document.documentElement.style.setProperty(`--ion-color-tertiary-rgb`, 'rgb(255,120,0)');
        document.documentElement.style.setProperty(`--ion-color-tertiary-shade`, 'rgb(255,120,0)');
        document.documentElement.style.setProperty(`--ion-color-tertiary-tint`, 'rgb(255,120,0)');
      }
    );
    this.subscriptions.add(sub);
  }

  // --- Calendar ---

  async addEventToCalendar(title: string, location: string, startDate: any[]): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      let [y, m, d, h, i] = startDate;
      let startTime = new Date(y, m, d, h, i, 0, 0);
      h = parseInt(h) + 1;
      let endDate = new Date(y, m, d, h, i, 0, 0);
      let notes = null;
      this.calendar.createEventInteractively(title, location, notes, startTime, endDate).then(
        (msg) => { console.log(msg); },
        (err) => { console.log(err); }
      );
    } else {
      let dataString = { title, location, startDate };
      (await this.request('post', false, 'ionic_postCreateICS', dataString)).subscribe(
        async (res) => {
          if (!res) return;
          let url = res.url;
          this.openPdf(url);
        }
      );
    }
  }

  // --- Misc ---

  updateClubName(value: string): void {
    this.clubName = value;
  }

  hasMultiClubs(value: boolean): void {
    this.multiClubs = value;
  }

  getSuccess() { return EMPTY; }
  getFailed() { return EMPTY; }
  getRetryFailed() { return EMPTY; }
  getAuthFailed() { return EMPTY; }
  getToken() { return this.userService.jwttoken; }

  // --- Push Permissions ---

  public async checkWebPushPermissions(): Promise<void> {
    let permission = await FirebaseMessaging.checkPermissions();
    if (permission.receive !== 'granted') {
      await FirebaseMessaging.requestPermissions();
      this.pushPermission.next(false);
    } else {
      this.getPushToken();
      this.pushPermission.next(true);
    }
  }

  public async getPushToken(): Promise<void> {
    const options: GetTokenOptions = {
      vapidKey: environment.firebase.vapidKey,
    };
    if (Capacitor.getPlatform() === "web") {
      options.serviceWorkerRegistration =
        await navigator.serviceWorker.register("firebase-messaging-sw.js");
    }
    const { token } = await FirebaseMessaging.getToken(options);
    let pushToken = token;
    await this.storage.setString('pushtoken', pushToken);
    this.registerToken(pushToken);
  }

  async shareDetails(detail: string): Promise<void> {
    await Share.share({ text: detail });
  }


    async getTabValues() {
    const sub = (await this.request('get', false, 'ionic_getAppTabValues', null)).subscribe(
      async (res) => {

     //console.log('getTabValues', res);

     this.tabValues.next(res);

      }
    );
    this.subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}